<div class="tabs-wrapper">
  <button class="editing-tab" [ngClass]="{'active': currentTab === 'diagram'}" (click)="showTab('diagram')">Workflow Steps</button>
  <button class="editing-tab" [ngClass]="{'active': currentTab === 'context'}" (click)="showTab('context')">Data Configuration</button>
</div>